<template>
    <button
        class="btn is-primary btn-sm btn-block"
        :class="{ 'is-loading': loading }"
        @click="approve"
    >
        Godkänn
    </button>
</template>
<script>
    export default {
        props: {
            anonymizationRequest: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                loading: false,
            };
        },

        methods: {
            approve() {
                this.loading = true;
                axios.patch(route('api.gdpr.anonymization-requests.approve', this.anonymizationRequest.id))
                    .then(() => {
                        this.$emit('approved');
                        flash_success('Anonymisering utförd!');
                    }).catch((error) => {
                        if (error.response.data.message) {
                            flash_error(error.response.data.message);
                            return;
                        }
                        flash_error('Åtgärden misslyckades.');
                    }).then(() => {
                        this.loading = false;
                    });
            },
        },
    };
</script>
